"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _rcTrigger = _interopRequireDefault(require("rc-trigger"));
var _div;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  anchorPosition: 'tr',
  popupPosition: 'tr',
  triggerOn: ['click'],
  closeOnClickOutside: true,
  closeOnEscInside: true,
  isFixed: false,
  getPopoverContainer: undefined,
  theme: {}
};
var noOp = function noOp() {};
var keyIdMap = {
  Enter: 'enter',
  Escape: 'esc'
};
var shouldIgnoreKeyDown = function shouldIgnoreKeyDown(key, className, tagName) {
  var keyId = keyIdMap[key];
  if (!keyId) {
    return true;
  }
  var regex = new RegExp("popover-if-".concat(keyId, "-pressed-ignore-close"));
  return tagName === 'HTML' || className && typeof className === 'string' && className.match(regex);
};

/**
 * Popup box that appears when the user clicks/hovers on an element
 */
var Popover = exports["default"] = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Popover, _Component);
  /* istanbul ignore next  */
  function Popover(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Popover);
    _this = _callSuper(this, Popover, [props]);
    _this.state = {
      isOpen: props.isOpen || false,
      hackBecauseThirdPartyCode: false
    };
    _this.originalAlignment = null;
    _this.togglePopOver = _this.togglePopOver.bind((0, _assertThisInitialized2["default"])(_this));
    _this.closePopOver = _this.closePopOver.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTriggerKeyDown = _this.handleTriggerKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePopoverContentClick = _this.handlePopoverContentClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePopoverContentKeyDown = _this.handlePopoverContentKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleVisiblityChange = _this.handleVisiblityChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleAlignmentChange = _this.handleAlignmentChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleVisiblityToggle = _this.handleVisiblityToggle.bind((0, _assertThisInitialized2["default"])(_this));
    _this.repositionHack = _this.repositionHack.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  // eslint-disable-next-line camelcase
  (0, _createClass2["default"])(Popover, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      /* istanbul ignore else  */
      if (nextProps.isOpen !== this.props.isOpen) {
        this.setState({
          isOpen: nextProps.isOpen
        });
      }
    }
  }, {
    key: "repositionHack",
    value: function repositionHack() {
      /* hack needed to correctly position tooltips. Remove at your peril. */
      this.setState({
        hackBecauseThirdPartyCode: true
      });
    }
  }, {
    key: "isNodeInPopup",
    value: function isNodeInPopup(node) {
      var getPopoverContainer = this.props.getPopoverContainer;
      var root = getPopoverContainer ? getPopoverContainer() : document.querySelector('.rc-trigger-popup:not(.rc-trigger-popup-hidden)');
      while (node) {
        if (node === root) {
          return true;
        }
        // eslint-disable-next-line
        node = node.parentNode;
      }
      return false;
    }
  }, {
    key: "handleVisiblityToggle",
    value: function handleVisiblityToggle(show) {
      var _this$props = this.props,
        triggerOn = _this$props.triggerOn,
        closeOnClickOutside = _this$props.closeOnClickOutside;
      if (triggerOn.indexOf('hover') > -1) {
        this.togglePopOver(window.event);
        return false;
      }

      /* istanbul ignore else  */
      var hasValidWindow = typeof window !== 'undefined' && window.event;
      var close = !show;
      var shouldClosePopover = closeOnClickOutside && close && hasValidWindow;
      if (shouldClosePopover) {
        var target = window.event.target;

        // This should not be necessary but we've seen rc-trigger
        // close the popup when a select control in a popup is clicked.
        var isClickInside = this.isNodeInPopup(target);
        if (!isClickInside) {
          this.closePopOver(window.event);
        }
      }
      return true;
    }
  }, {
    key: "handleVisiblityChange",
    value: function handleVisiblityChange(visible) {
      var onVisiblityChange = this.props.onVisiblityChange;
      /* callback for visiblity change */
      if (onVisiblityChange) {
        onVisiblityChange(visible);
      }
    }
  }, {
    key: "handleAlignmentChange",
    value: function handleAlignmentChange(align) {
      // set original alignment value
      if (!this.originalAlignment) {
        this.originalAlignment = align.points;
      }
      // if alignment fixed automatically, add class
      if (this.originalAlignment !== align.points) {
        var newPosition = '';
        for (var i = 0; i < align.points.length; i += 1) {
          var prefix = i === 0 ? 'popup-' : 'target-';
          newPosition += "".concat(prefix).concat(align.points[i], " ");
        }
        return "alignment-override ".concat(newPosition);
      }
      return '';
    }

    /**
     * Called as the onClick behavior for the popup contents. Ensures that a click
     * inside the popover does not unintentionally close it.
     */
  }, {
    key: "handlePopoverContentClick",
    value: function handlePopoverContentClick(e) {
      var _this$props2 = this.props,
        triggerOn = _this$props2.triggerOn,
        closeOnClickInside = _this$props2.closeOnClickInside;
      var el = e.target;
      var className = el.className,
        tagName = el.tagName;
      var ignoreElementClicked = className && typeof className === 'string' && className.match(/popover-if-clicked-ignore-close/);
      e.stopPropagation();

      /* istanbul ignore else  */
      if (triggerOn.indexOf('click') === -1 || ignoreElementClicked) {
        return false;
      }

      // Set dom node for checking if clicked inside
      var isClickInside = this.isNodeInPopup(el);
      /* istanbul ignore else  */
      if (isClickInside && tagName !== 'HTML' && closeOnClickInside) {
        this.togglePopOver(e);
      }
      return true;
    }
  }, {
    key: "handlePopoverContentKeyDown",
    value: function handlePopoverContentKeyDown(e) {
      e.stopPropagation();
      var key = e.key,
        target = e.target;
      var className = target.className,
        tagName = target.tagName;
      var _this$props3 = this.props,
        closeOnEnterInside = _this$props3.closeOnEnterInside,
        closeOnEscInside = _this$props3.closeOnEscInside;
      if (shouldIgnoreKeyDown(key, className, tagName)) {
        return;
      }
      if (key === 'Enter' && closeOnEnterInside) {
        this.closePopOver(e);
      } else if (key === 'Escape' && closeOnEscInside) {
        this.closePopOver(e);
      }
    }
  }, {
    key: "togglePopOver",
    value: function togglePopOver(e) {
      var openState = !this.state.isOpen;
      var _this$props4 = this.props,
        onOpen = _this$props4.onOpen,
        onClose = _this$props4.onClose;
      this.setState({
        isOpen: openState
      }, this.repositionHack);
      if (openState && onOpen) {
        onOpen(e);
      } else if (!openState && onClose) {
        onClose(e);
      }
    }
  }, {
    key: "closePopOver",
    value: function closePopOver(e) {
      var _this2 = this;
      var onClose = this.props.onClose;
      this.setState({
        isOpen: false
      }, function () {
        if (onClose) {
          onClose(e);
        }
        return _this2.repositionHack();
      });
    }
  }, {
    key: "handleTriggerKeyDown",
    value: function handleTriggerKeyDown(e) {
      if (e.key === 'Enter') {
        return this.togglePopOver(e);
      }
      if (e.key === 'Escape') {
        return this.closePopOver(e);
      }
      return null;
    }
  }, {
    key: "renderPopoverContent",
    value: function renderPopoverContent() {
      var content = this.props.content;
      return content && /*#__PURE__*/_react["default"].cloneElement(content, {
        onClick: this.handlePopoverContentClick,
        onKeyDown: this.handlePopoverContentKeyDown
      });
    }
  }, {
    key: "renderTrigger",
    value: function renderTrigger() {
      var _this$props5 = this.props,
        triggerComponent = _this$props5.triggerComponent,
        triggerOn = _this$props5.triggerOn,
        children = _this$props5.children,
        testId = _this$props5.testId,
        theme = _this$props5.theme;
      var newTrigger = triggerComponent || children;

      /** conditionally set clickhandler to toggle or noOp */
      var clickHandler = triggerOn.indexOf('click') === -1 ? noOp : this.togglePopOver;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.triggerWrapper,
        role: "button",
        tabIndex: "0",
        onClick: clickHandler,
        onKeyDown: this.handleTriggerKeyDown,
        "data-test-id": testId && "".concat(testId, "-trigger-wrap"),
        "aria-haspopup": "true",
        "aria-expanded": this.state.isOpen
      }, newTrigger);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        className = _this$props6.className,
        anchorPosition = _this$props6.anchorPosition,
        popupPosition = _this$props6.popupPosition,
        triggerOn = _this$props6.triggerOn,
        offset = _this$props6.offset,
        getPopoverContainer = _this$props6.getPopoverContainer,
        isFixed = _this$props6.isFixed,
        theme = _this$props6.theme,
        testId = _this$props6.testId;
      var initialOpenState = this.props.isOpen;
      var isOpen = this.state.isOpen;
      var offsetSettings = offset || [0, 0];
      var popoverTrigger = this.renderTrigger();
      var classes = (0, _classnames["default"])(theme.popoverTrigger, /* localized styles */
      className, /* user specified classNames */"content-shown-".concat(isOpen) /* prop based classnames */);
      var trigger = /*#__PURE__*/_react["default"].createElement(_rcTrigger["default"], {
        popupAlign: {
          offset: offsetSettings,
          // [x, y]
          overflow: {
            adjustX: 1,
            adjustY: 1
          },
          points: [popupPosition, anchorPosition]
        },
        popupVisible: this.state.isOpen,
        getPopupContainer: getPopoverContainer,
        defaultPopupVisible: initialOpenState,
        onPopupVisibleChange: this.handleVisiblityToggle,
        afterPopupVisibleChange: this.handleVisiblityChange,
        getPopupClassNameFromAlign: this.handleAlignmentChange,
        action: triggerOn,
        popupClassName: (0, _classnames["default"])(theme.popoverContent, 'dropdown-menu-popup', (0, _defineProperty2["default"])({}, theme.popoverFixed, isFixed)),
        popup: isOpen ? this.renderPopoverContent() : _div || (_div = /*#__PURE__*/_react["default"].createElement("div", null))
      }, popoverTrigger);
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: classes,
        "data-test-id": testId,
        "data-anypoint-component": Popover.displayName
      }, trigger);
    }
  }]);
  return Popover;
}(_react.Component);
(0, _defineProperty2["default"])(Popover, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Popover, "displayName", 'Popover');
//# sourceMappingURL=Popover.js.map